<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-6 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <div
          class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
        >
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            {{ $t("common.app_name") }}
          </h1>
          <ul
            class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
          >
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">{{
                $t("common.home")
              }}</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">{{ $t("prv.title") }}</li>
          </ul>
        </div>

        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <button
            @click="$router.go(-1)"
            class="btn btn-light"
            style="
              font-weight: 600;
              padding: 8px 20px;
              margin-left: 15px;
              background: #d7d7d745;
            "
          >
            {{ $t("common.back") }}
            <i
              class="fa fa-arrow-left"
              style="color: #07c232; margin-right: 10px"
            ></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!-- التحميل -->
        <div
          v-if="isLoading"
          class="loader text-success"
          style="
            font-weight: 800;
            border-radius: 10px;
            padding: 50px;
            font-size: large;
            text-align: center;
            background: #73737326;
          "
        >
          {{ $t("common.loading") }}
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>

        <!-- غير مسجّل -->
        <div v-else-if="!isLoggedIn" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">{{ $t("common.please_login_to_continue") }}</h3>
            <span
              ><a href="login" class="btn btn-success"
                >{{ $t("common.login") }} <i class="fa fa-sign-in"></i></a
            ></span>
          </div>
        </div>

        <!-- المحتوى -->
        <div v-else class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="col-12">
            <div class="card shadow-sm">
              <div class="card-header text-white" style="background: #03c044">
                <h3 class="card-title" style="color: #fff">
                  {{ $t("prv.new_booking") }}
                  <i
                    class="fa fa-plus-circle text-white"
                    style="margin: 5px"
                  ></i>
                </h3>
              </div>

              <div class="card-body">
                <p class="text-muted">
                  {{ $t("prv.select_hint") }}
                </p>
                <hr />

                <!-- صناديق الاختيار -->
                <div class="row mb-4">
                  <!-- الفئات -->
                  <div class="col-md-4">
                    <label for="categoriesSelect" class="form-label">{{
                      $t("prv.categories")
                    }}</label>
                    <select
                      id="categoriesSelect"
                      class="form-select"
                      v-model="selectedCategoryId"
                    >
                      <option :value="null" disabled>
                        {{ $t("prv.select_stage") }}
                      </option>
                      <option
                        v-for="cat in categoriesData"
                        :key="cat.id"
                        :value="cat.id"
                        :disabled="!cat.enabled"
                        :style="{ color: !cat.enabled ? '#b5b5b5' : 'inherit' }"
                      >
                        {{ cat.title }}
                      </option>
                    </select>
                  </div>

                  <!-- التخصصات -->
                  <div class="col-md-4">
                    <label for="subCategoriesSelect" class="form-label">{{
                      $t("prv.subcategories")
                    }}</label>
                    <select
                      id="subCategoriesSelect"
                      class="form-select"
                      v-model="selectedSubCategoryId"
                      :disabled="subCategories.length === 0"
                    >
                      <option :value="null" disabled>
                        {{ $t("prv.select_year") }}
                      </option>
                      <option
                        v-for="sub in subCategories"
                        :key="sub.id"
                        :value="sub.id"
                        :disabled="!sub.enabled"
                        :style="{ color: !sub.enabled ? '#b5b5b5' : 'inherit' }"
                      >
                        {{ sub.title }}
                      </option>
                    </select>
                  </div>

                  <!-- التخصصات الفرعية -->
                  <div class="col-md-4">
                    <label for="childCategoriesSelect" class="form-label">{{
                      $t("prv.child_categories")
                    }}</label>
                    <select
                      id="childCategoriesSelect"
                      class="form-select"
                      v-model="selectedChildCategoryId"
                      :disabled="childCategories.length === 0"
                    >
                      <option :value="null" disabled>
                        {{ $t("prv.select_subject") }}
                      </option>
                      <option
                        v-for="child in childCategories"
                        :key="child.id"
                        :value="child.id"
                        :disabled="!child.enabled"
                        :style="{
                          color: !child.enabled ? '#b5b5b5' : 'inherit',
                        }"
                      >
                        {{ child.title }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- /.row -->
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
          <!-- رسالة توجيه -->
          <div v-if="dynamicMsg" class="mt-4">
            <div
              class="card"
              style="
                border-left: 6px solid #03c546;
                border-right: 6px solid #03c546;
              "
            >
              <div class="card-body text-center text-dark fw-bold">
                <i
                  class="bi bi-info-circle-fill fs-2 mb-2"
                  style="color: #03c546"
                ></i>
                <div class="fs-5">{{ dynamicMsg }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- المحتوى -->
        <div>
          <!-- بطاقات المدرّسين -->
          <div class="row g-5 g-xl-10 mb-5">
            <div v-if="slotsLoading" class="text-center w-100 my-4">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">{{ $t("common.loading") }}</span>
              </div>
              <div class="mt-2">{{ $t("prv.loading_sessions") }}</div>
            </div>
            <!-- رسالة توجيه -->

            <div v-for="ins in instructors" :key="ins.id" class="col-md-4">
              <div class="card mb-5 mt-5 shadow-sm">
                <!-- Header  -->
                <div class="card-body pb-0">
                  <div class="d-flex align-items-center mb-4">
                    <div class="symbol symbol-50px me-4">
                      <img
                        :src="imageUrl(ins.image)"
                        :alt="ins.name"
                        @error="onImageError"
                      />
                    </div>

                    <div class="flex-grow-1">
                      <div class="fw-bold text-gray-900">{{ ins.name }}</div>
                      <div class="text-gray-400">
                        {{ ins.subjects.map((s) => s.title).join("، ") || "—" }}
                      </div>
                    </div>

                    <!-- Rating -->
                    <div class="rating">
                      <template
                        v-for="(filled, i) in stars(ins.rating)"
                        :key="i"
                      >
                        <i
                          class="bi bi-star-fill"
                          :class="{ 'text-warning': filled }"
                        ></i>
                      </template>
                    </div>
                  </div>

                  <!-- PRICES -->
                  <div class="d-flex mb-3">
                    <!-- فردي -->
                    <div
                      class="border rounded p-1 me-2 d-flex align-items-center"
                      style="min-width: 75px; justify-content: center"
                    >
                      <i class="bi bi-person fs-6 me-1"></i>
                      {{ ins.default_single_private_session_price }}
                      {{ $appCurrency }}
                    </div>
                    <!-- جماعي -->
                    <div
                      class="border rounded p-1 d-flex align-items-center"
                      style="min-width: 75px; justify-content: center"
                    >
                      <i class="bi bi-people fs-6 me-1"></i>
                      {{ ins.default_group_private_session_price }}
                      {{ $appCurrency }}
                    </div>
                  </div>

                  <!-- ACTIONS  -->
                  <div class="d-flex justify-content-between mb-2">
                    <button
                      class="btn btn-light btn-sm fw-bold"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#collapse-' + ins.id"
                    >
                      {{ $t("prv.nearest_session") }}
                      <i class="bi bi-chevron-down ms-1"></i>
                    </button>
                    <button
                      class="btn btn-outline-light btn-sm fw-bold"
                      @click="openScheduleModal(ins.id, ins.image)"
                      style="color: #00c346; font-weight: 800 !important"
                    >
                      {{ $t("prv.book_later") }}
                      <i class="fa fa-arrow-left" style="color: #00c346"></i>
                    </button>
                  </div>

                  <!-- COLLAPSE -->
                  <div :id="'collapse-' + ins.id" class="collapse mt-1">
                    <div class="text-gray-800 p-2">
                      <div
                        class="border rounded p-1 mb-2 d-flex align-items-center"
                      >
                        <h2>
                          <b> {{ ins.slot.title }} </b>
                        </h2>
                      </div>
                      <!-- مدة الجلسة -->
                      <div class="d-flex mb-2">
                        <i class="bi bi-hourglass-split me-2"></i>
                        <span>
                          <b>{{ $t("prv.duration_label") }}:</b>
                          {{
                            getDuration(ins.slot.start_date, ins.slot.end_date)
                          }}
                        </span>
                      </div>

                      <!-- النوع -->
                      <div
                        class="border rounded p-1 mb-2 d-flex align-items-center"
                      >
                        <i class="bi bi-film me-2"></i>
                        <span
                          ><b>{{ $t("prv.type_label") }}:</b>
                          {{
                            ins.slot.type === "video"
                              ? $t("prv.type.video")
                              : ins.slot.type
                          }}</span
                        >
                      </div>
                      <div
                        class="border rounded p-1 mb-2 d-flex align-items-center"
                      >
                        <i class="bi bi-people-fill me-1"></i>
                        <span
                          ><b> {{ $t("prv.available_seats") }}:</b>
                          {{ ins.slot.max_audience }}/{{
                            booked(ins.slot)
                          }}</span
                        >
                      </div>
                      <button
                        class="btn btn-success btn-sm fw-bold"
                        @click="reserveSlot(ins.slot.id)"
                      >
                        {{ $t("prv.reserve_now") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- الترحيل بين الصفحات -->
          <nav
            v-if="pagerMeta.total > pagerMeta.per_page"
            :aria-label="$t('prv.pagination_label')"
          >
            <ul class="pagination justify-content-center">
              <!-- Previous -->
              <li class="page-item" :class="{ disabled: !pagerLinks.prev }">
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="goToPage(pagerLinks.prev)"
                  v-html="'&laquo;'"
                ></a>
              </li>

              <!-- أرقام الصفحات -->
              <li
                v-for="link in pagerMeta.links"
                :key="link.label"
                class="page-item"
                :class="{ active: link.active, disabled: !link.url }"
              >
                <a
                  v-if="link.url"
                  class="page-link"
                  href="#"
                  @click.prevent="goToPage(link.url)"
                  v-html="link.label"
                ></a>
                <span v-else class="page-link" v-html="link.label"></span>
              </li>

              <!-- Next -->
              <li class="page-item" :class="{ disabled: !pagerLinks.next }">
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="goToPage(pagerLinks.next)"
                  v-html="'&raquo;'"
                ></a>
              </li>
            </ul>
          </nav>
        </div>

        <!-- /.row -->
      </div>
      <!-- /.container -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.wrapper -->

  <!-- MODAL -->
  <!-- MODAL -->
  <!-- ==================== MODAL ====================== -->
  <div class="modal fade" id="scheduleModal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">إختيار موعد لاحق</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          ></button>
        </div>

        <div class="modal-body">
          <!-- TABS -->
          <ul class="nav nav-tabs mb-3">
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ active: activeTab === 'group' }"
                @click="
                  activeTab = 'group';
                  fetchSlotsByGroup(1);
                "
              >
                جماعي
              </button>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ active: activeTab === 'single' }"
                @click="
                  activeTab = 'single';
                  fetchSlotsByGroup(0);
                "
              >
                فردي
              </button>
            </li>
          </ul>

          <!-- LOADING -->
          <div v-if="slotsLoadingModal" class="text-center py-5">
            جاري التحميل...
          </div>

          <!-- =============== GROUP SLOTS =============== -->
          <div v-if="activeTab === 'group' && !slotsLoading">
            <!-- Empty -->
            <div
              v-if="groupSlots.length === 0"
              class="text-center py-5 text-muted"
            >
              <i class="bi bi-exclamation-circle fs-1 d-block mb-2"></i>
              <span class="fs-4">لا توجد جلسات متاحة حالياً</span>
            </div>

            <!-- List -->
            <div v-else>
              <div
                v-for="slot in groupSlots"
                :key="slot.id"
                class="card mb-3 shadow-sm"
              >
                <div class="card-body">
                  <!-- Header -->
                  <div class="d-flex align-items-center mb-3">
                    <img
                      style="padding: 1px; border: 1px solid #00b352 !important"
                      :src="imageUrl(modalInstructorImage)"
                      width="60"
                      height="60"
                      class="rounded-circle border me-3"
                    />
                    <div>
                      <div class="fw-bold fs-5 text-dark">{{ slot.title }}</div>
                      <div class="text-muted">
                        {{ slot.child_category_name }}
                      </div>
                    </div>
                    <button
                      style="background-color: #00b352"
                      class="btn btn-success btn-sm ms-auto"
                      @click="reserveSlot(slot.id)"
                    >
                      حجز
                      <i class="fa fa-arrow-left"></i>
                    </button>
                  </div>

                  <div class="row g-2">
                    <div class="col-md-3 col-6">
                      <div class="border rounded p-2 text-center">
                        <i class="bi bi-film d-block mb-1"></i>
                        <small class="text-muted">نوع الجلسة</small>
                        <div class="fw-bold">
                          {{ slot.type === "video" ? "فيديو" : slot.type }}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 col-6">
                      <div class="border rounded p-2 text-center">
                        <i class="bi bi-cash-coin d-block mb-1"></i>
                        <small class="text-muted">السعر</small>
                        <div class="fw-bold text-success">
                          {{ slot.price }} {{ $appCurrency }}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 col-6">
                      <div class="border rounded p-2 text-center">
                        <i class="bi bi-hourglass-split d-block mb-1"></i>
                        <small class="text-muted">المدة</small>
                        <div class="fw-bold">
                          {{ getDuration(slot.start_date, slot.end_date) }}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 col-6">
                      <div class="border rounded p-2 text-center">
                        <i class="bi bi-people-fill d-block mb-1"></i>
                        <small class="text-muted">المقاعد</small>
                        <div class="fw-bold">{{ slot.max_audience }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PAGINATION (GROUP) -->
            <nav v-if="groupPagerMeta && groupPagerMeta.last_page > 1">
              <ul class="pagination justify-content-center">
                <li
                  class="page-item"
                  :class="{ disabled: !groupPagerLinks.prev }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="fetchSlotsByGroup(1, groupPagerLinks.prev)"
                    >السابق</a
                  >
                </li>
                <li
                  class="page-item"
                  :class="{ disabled: !groupPagerLinks.next }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="fetchSlotsByGroup(1, groupPagerLinks.next)"
                    >التالي</a
                  >
                </li>
              </ul>
            </nav>
          </div>

          <!-- =============== SINGLE SLOTS =============== -->
          <div v-if="activeTab === 'single' && !slotsLoading">
            <!-- Empty -->
            <div
              v-if="singleSlots.length === 0"
              class="text-center py-5 text-muted"
            >
              <i class="bi bi-exclamation-circle fs-1 d-block mb-2"></i>
              <span class="fs-4">لا توجد جلسات متاحة حالياً</span>
            </div>

            <!-- List -->
            <div v-else>
              <div
                v-for="slot in singleSlots"
                :key="slot.id"
                class="card mb-3 shadow-sm"
              >
                <div class="card-body">
                  <div class="d-flex align-items-center mb-3">
                    <img
                      :src="imageUrl(modalInstructorImage)"
                      width="60"
                      height="60"
                      class="rounded-circle border me-3"
                    />
                    <div>
                      <div class="fw-bold fs-5 text-dark">{{ slot.title }}</div>
                      <div class="text-muted">
                        {{ slot.child_category_name }}
                      </div>
                    </div>
                    <button
                      class="btn btn-success btn-sm ms-auto"
                      @click="reserveSlot(slot.id)"
                    >
                      حجز
                    </button>
                  </div>

                  <div class="row g-2">
                    <div class="col-md-3 col-6">
                      <div class="border rounded p-2 text-center">
                        <i class="bi bi-film d-block mb-1"></i>
                        <small class="text-muted">نوع الجلسة</small>
                        <div class="fw-bold">
                          {{ slot.type === "video" ? "فيديو" : slot.type }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 col-6">
                      <div class="border rounded p-2 text-center">
                        <i class="bi bi-cash-coin d-block mb-1"></i>
                        <small class="text-muted">السعر</small>
                        <div class="fw-bold text-success">
                          {{ slot.price }} {{ $appCurrency }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 col-6">
                      <div class="border rounded p-2 text-center">
                        <i class="bi bi-hourglass-split d-block mb-1"></i>
                        <small class="text-muted">المدة</small>
                        <div class="fw-bold">
                          {{ getDuration(slot.start_date, slot.end_date) }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 col-6">
                      <div class="border rounded p-2 text-center">
                        <i class="bi bi-people-fill d-block mb-1"></i>
                        <small class="text-muted">المقاعد</small>
                        <div class="fw-bold">{{ slot.max_audience }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PAGINATION (SINGLE) -->
            <nav v-if="singlePagerMeta && singlePagerMeta.last_page > 1">
              <ul class="pagination justify-content-center">
                <li
                  class="page-item"
                  :class="{ disabled: !singlePagerLinks.prev }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="fetchSlotsByGroup(0, singlePagerLinks.prev)"
                    >السابق</a
                  >
                </li>
                <li
                  class="page-item"
                  :class="{ disabled: !singlePagerLinks.next }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="fetchSlotsByGroup(0, singlePagerLinks.next)"
                    >التالي</a
                  >
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ==================== END MODAL ====================== -->
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
import Swal from "sweetalert2";

export default {
  name: "SessionsList",

  data() {
    return {
      /* --------- قائم كما هو --------- */
      categoriesData: [],
      selectedCategoryId: null,
      selectedSubCategoryId: null,
      selectedChildCategoryId: null,
      isLoading: true,
      slotsLoading: false,
      isLoggedIn: false,
      token: localStorage.getItem("access_token"),
      // ... باقي متغيراتك
      modalInstructorId: null,
      modalInstructorImage: null,

      activeTab: "group",

      groupSlots: [],
      singleSlots: [],

      groupPagerLinks: null,
      groupPagerMeta: null,
      singlePagerLinks: null,
      singlePagerMeta: null,

      slotsLoadingModal: false,
      /* --------- جديد --------- */
      instructors: [], // البيانات التى سنعرضها
      pagerLinks: {}, // prev / next / first / last
      pagerMeta: {}, // current_page, links[], ...
      instructorImgPath: baseUrl + "/images/instructors/", // عدِّل المسار إذا لزم

      /* أي شيء آخر */
      defaultImage: "/assets/img/acad-icon.png",
    };
  },

  computed: {
    /** التخصصات حسب الفئة المختارة */
    subCategories() {
      if (!this.selectedCategoryId) return [];
      const cat = this.categoriesData.find(
        (c) => c.id == this.selectedCategoryId
      );
      return cat?.sub_categories ?? [];
    },

    // 👇 الجديد
    dynamicMsg() {
      // لا يوجد فئة مختارة
      if (!this.selectedCategoryId) {
        return "الآن قم باختيار المرحلة الدراسية ";
      }
      // لا يوجد تخصص مختار
      if (!this.selectedSubCategoryId) {
        return "الآن قم باختيار السنة الدراسية ";
      }
      // لا يوجد تخصص فرعي مختار
      if (!this.selectedChildCategoryId) {
        // لو مافيش childCategories أصلا
        if (this.childCategories.length === 0) {
          return "لا يوجد مواد دراسية  لهذه المرحلة ";
        }
        return "الآن قم باختيار التخصص الفرعي";
      }
      // عند وجود تخصص فرعي → نعرض الرسالة الأخيرة (مثلاً جاري جلب الجلسات)
      if (this.instructors.length === 0 && this.slotsLoading === false) {
        return "لا توجد جلسات متاحة ";
      }
      return null; // لا شيء
    },
    /** التخصصات الفرعية حسب التخصص المختار */
    childCategories() {
      if (!this.selectedSubCategoryId) return [];
      const sub = this.subCategories.find(
        (s) => s.id == this.selectedSubCategoryId
      );
      return sub?.child_categories ?? [];
    },
  },

  watch: {
    selectedCategoryId() {
      this.selectedSubCategoryId = null;
      this.selectedChildCategoryId = null;
    },
    selectedSubCategoryId() {
      this.selectedChildCategoryId = null;
    },
    /* عند اختيار التخصص الفرعي نحضّر الطلب مع كل الحقول المطلوبة */
    async selectedChildCategoryId(newVal) {
      if (newVal) await this.getAvailableSlots();
    },
  },

  mounted() {
    this.getCategories();
  },

  methods: {
    booked(slot) {
      const max = parseInt(slot.max_audience);
      const seats = parseInt(slot.seats); // seats = المتبقية حاليا
      return max - seats; // عدد المحجوزة
    },
    getDuration(start, end) {
      const s = new Date(start);
      const e = new Date(end);

      // لو أي واحد منهم invalid → رجع خط فاضي
      if (isNaN(s.getTime()) || isNaN(e.getTime())) {
        return "";
      }

      const diffMs = e.getTime() - s.getTime();
      const diffMin = Math.floor(diffMs / 1000 / 60);

      if (diffMin < 60) {
        return diffMin + " دقيقة";
      } else {
        const h = Math.floor(diffMin / 60);
        const m = diffMin % 60;
        return h + " ساعة" + (m ? " و " + m + " دقيقة" : "");
      }
    },
    /** جلب الفئات من الـAPI */
    async getCategories() {
      this.isLoading = true;
      try {
        const res = await fetch(`${apiUrl}/live-sessions/get-categories`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (res.ok) {
          this.isLoggedIn = true;
          var categoriesDataResponse = await res.json();

          this.categoriesData = categoriesDataResponse.categories;
        } else {
          console.error("Failed to fetch categories");
        }
      } catch (e) {
        console.error("Error fetching categories:", e);
      } finally {
        this.isLoading = false;
      }
    },
    async getAvailableSlots(pageUrl = null) {
      this.slotsLoading = true;

      const endpoint = pageUrl || `${apiUrl}/live-sessions/get-available-slots`;

      const payload = {
        category_id: this.selectedCategoryId,
        sub_category_id: this.selectedSubCategoryId,
        child_category_id: this.selectedChildCategoryId,
        live: true,
        whole_slots: true,
      };

      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) throw new Error(res.status);

        const json = await res.json();
        /* بيانات الـ API مُهيكلة هكذا: { instructors: { data: [], links:{}, meta:{} } } */
        const wrapper = json.instructors;

        this.instructors = wrapper.data;
        this.pagerLinks = wrapper.links;
        this.pagerMeta = wrapper.meta;
      } catch (err) {
        console.error("❌ getAvailableSlots:", err);
      } finally {
        this.slotsLoading = false;
      }
    },
    async reserveSlot(slotId) {
      // أولاً: نطلب تأكيد من المستخدم
      const result = await Swal.fire({
        title: "هل أنت متأكد من الحجز؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "نعم، احجز الآن",
        cancelButtonText: "إلغاء",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        // إذا أكد المستخدم
        Swal.fire({
          title: "جاري الحجز...",
          text: "يرجى الانتظار قليلاً",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        try {
          const endpoint = `${apiUrl}/live-sessions/reserve`;
          const payload = { slot_id: slotId };

          const res = await fetch(endpoint, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });

          if (!res.ok) throw new Error(res.status);

          const json = await res.json();
          if (
            json.status === "error" &&
            json.message === "Already reserved a place in the session!"
          ) {
            // رسالة تحذير
            Swal.fire({
              icon: "warning",
              title: "تنبيه !",
              text: json.message,
            });
          } else {
            // رسالة نجاح
            Swal.fire({
              icon: "success",
              title: "تم الحجز بنجاح!",
              text: json.message || "تم تسجيلك في الجلسة.",
            });
            const slot = this.instructors.find(
              (x) => x.slot.id === slotId
            ).slot;
            if (parseInt(slot.seats) > 0) {
              slot.seats = parseInt(slot.seats) - 1;
            }
          }
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: "حدث خطأ",
            text: "لم يتم الحجز. يرجى المحاولة لاحقًا.",
          });
          console.error("Reservation Error:", err);
        } finally {
          this.slotsLoading = false;
        }
      } else {
        // إذا ألغى المستخدم التأكيد ما نعمل شيء
        console.log("User canceled the reservation");
      }
    },

    /* ---------- الإنتقال بين الصفحات ---------- */
    async goToPage(url) {
      if (!url) return;
      // الـ API يقبل استدعاء GET بالرابط الكامل، لذلك نستخدمه كما هو
      await this.getAvailableSlots(url);
    },
    async openScheduleModal(instructorId, instructorImage) {
      this.modalInstructorId = instructorId;
      this.modalInstructorImage = instructorImage;
      this.activeTab = "group";

      // أول تحميل للتاب الجماعي
      await this.fetchSlotsByGroup(1);

      const modal = new bootstrap.Modal(
        document.getElementById("scheduleModal")
      );
      modal.show();
    },

    async fetchSlotsByGroup(group, page = null) {
      this.slotsLoadingModal = true;

      const endpoint = page || `${apiUrl}/live-sessions/get-available-slots`;

      const payload = {
        category_id: this.selectedCategoryId,
        sub_category_id: this.selectedSubCategoryId,
        child_category_id: this.selectedChildCategoryId,
        instructor_id: this.modalInstructorId,
        group,
        live: true,
        whole_slots: true,
      };

      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const json = await res.json();

        if (group === 1) {
          this.groupSlots = json.data;
          this.groupPagerLinks = json.links;
          this.groupPagerMeta = json.meta;
        } else {
          this.singleSlots = json.data;
          this.singlePagerLinks = json.links;
          this.singlePagerMeta = json.meta;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.slotsLoadingModal = false;
      }
    },

    /* ---------- مساعدات صغيرة للعرض ---------- */
    imageUrl(img) {
      return img ? img : this.defaultImage;
    },
    onImageError(event) {
      event.target.src = this.defaultImage;
    },
    /* يحوِّل التاريخ إلى 07/07/2025 12:30 */
    formatDateTime(dt) {
      const d = new Date(dt.replace(" ", "T")); // يدعم Safari
      return (
        d.toLocaleDateString("en-US") +
        " " +
        d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
      );
    },
    /* يحوّل 3.7 إلى مصفوفة طولها 5 لتلوين النجوم */
    stars(rating) {
      const r = Math.round(Number(rating) || 0);
      return Array.from({ length: 5 }, (_, i) => i < r);
    },
    /* هل الجلسة حالياً جارية؟ */
    isLive(slot) {
      const now = Date.now();
      return new Date(slot.start_date) <= now && now <= new Date(slot.end_date);
    },
    timeRange(slot) {
      const s = new Date(slot.start_date);
      const e = new Date(slot.end_date);
      const opts = { hour: "2-digit", minute: "2-digit" };
      return `من ${s.toLocaleTimeString(
        "en-US",
        opts
      )} إلى ${e.toLocaleTimeString("en-US", opts)}`;
    },
  },
};
</script>

<style scoped>
/* ضع تنسيقاتك الإضافية هنا عند الحاجة */
</style>
